<template>
    <card-list-item @click="$emit('click')" :class="{'active': active, 'no-pointer': !clickable}">
        <template v-slot:icon><i class="fa-file-invoice-dollar fa-fw" :class="{'fas': active, 'far': !active}"></i></template>
        <template v-slot:content>
            <div class="tile-title">{{quote.user.first_name}} {{quote.user.last_name}}</div>
            <div class="meta"><i class="fas fa-fw fa-at mr-2"></i>{{quote.user.email}}</div>
            <div class="meta" v-if="quote.reseller"><i class="fas fa-fw fa-user-tie mr-2"></i>{{quote.reseller.firstName}} {{quote.reseller.lastName}}</div>
            <div class="meta" v-if="quote.term == 0"><i class="fas fa-fw fa-shopping-cart mr-2"></i>Cart Enrollment</div>
            <div class="meta" v-else><i class="fas fa-fw fa-money-check-alt mr-2"></i>Payment Plan</div>
        </template>
        <template v-slot:status>
            <div class="stats">
                <span class="stat"><i class="fal fa-triangle"></i>{{quote.status | capitalize}}</span>
            </div>
        </template>
        <template v-slot:details>
            <div class="mt-3">
                <toolbar class="toolbar">
                    <button class="icon-only" @click.stop=""><i class="far fa-pencil"></i></button>
                </toolbar>

                <div class="data mt-1">
                    <data-row mini title="Title">{{quote.title}}</data-row>
                    <data-row mini title="Hours">{{quote.hours}}</data-row>
                    <data-row mini title="Total">{{quote.total | currency}}</data-row>
                    <data-row mini title="Term">{{quote.term}} months</data-row>
                    <data-row mini title="Defer">{{quote.defer_on | moment('MMMM Do YYYY')}}</data-row>
                    <data-row mini title="Created">{{quote.created_at | moment('MMMM Do YYYY, h:mm:ss a')}}</data-row>
                    <data-row mini title="ID">{{quote.id}}</data-row>
                </div>
            </div>
        </template>
    </card-list-item>
</template>

<script>
    import Toolbar from "@/TIER/components/Toolbar";
    import DataRow from "@/TIER/components/DataRow";
    import CardListItem from "@/TIER/components/CardListItem";

    export default {
        name: 'QuoteTile',
        components: {CardListItem, DataRow, Toolbar},
        props: {
            card: {
                required: true
            },
            quote: {
                type: Object,
                required: true
            },
            active: {
                type: Boolean,
                default: false
            },
            clickable: {
                type: Boolean,
                default: true
            }
        },
        data: function () {
            return {
                details: false,
            }
        }
    }
</script>

<style lang="scss" scoped>
    .tile-title {
        font-size: 0.9rem;
        font-weight: bold;
    }

    .no-pointer {
        cursor: default !important;
    }
</style>
